import React, { useEffect } from 'react';
import AccordionMoretti from './components/accordion/accordion.component';
import TreImmagini from './components/treimmagini/treimmagini.componet';
import CtaTreIcone from './components/ctatreicone/ctatreicone.component';
import PuntiDiForza from './components/puntidiforza/puntidiforza.component';
import LightEffectSection from './components/lightsection/lightsection.component';
import ImmTesto from './components/immtesto/immtesto.component';
import CtaTesto from './components/ctatesto/ctatesto.component';
import Footer from './components/footer/footer.component';
import PercheScegliere from './components/perchescegliere/perchescegliere.component';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function App() {
  useEffect(() => {
    AOS.init();
  }, []);
  const ctatesti = [
    {
      row1: 'Fai il Prossimo Passo!',
      row2: 'Contattaci Subito!',
      row3: 'Scrivici una mail e usa il codice <br><span class="font-black">PROMO MORETTI</span>',
      row4: 'Un nostro esperto ti risponderà subito con tutte le informazioni per finalizzare l’ordine.'
    }
  ];
  const firstcontent = [
    {
      red: 'Offerta Imperdibile!',
      prodotto: 'F4 <br/>Transpallet elettrico 1,5 t',
      prezzo: '€999,00 +iva',
      testosotto: 'Capacità di carico: <br/><span class="font-black">1,5 tonnellate</span> <br/>Batteria: <br/><span class="font-black">Li-ion rimovibili</span>'
    }
  ];

  const imagestreimmagini = [
    '/images/02.webp',
    '/images/03.webp',
    '/images/05.webp',
  ];

  const faqs = [
    {
      question: "Cosa rende l'F4 diverso dagli altri carrelli elevatori a pallet?",
      answer: (
        <span>
          L’F4 è progettato come un tuttofare, con molteplici dimensioni delle forche, ruote stabilizzanti opzionali e fino a quattro batterie Li-ion rimovibili, rendendolo adattabile sia ad applicazioni leggere che intensive.
        </span>
      ),
    },
    {
      question: "Quante batterie supporta l'F4?",
      answer: (
        <span>
          L’F4 può essere dotato di fino a due batterie Li-ion da 24V/20Ah in uso standard e fino a quattro batterie come opzione, garantendo il massimo tempo di operatività per operazioni a turno completo.
        </span>
      ),
    },
    {
      question: "L'F4 è adatto per corridoi stretti?",
      answer: (
        <span>
          Sì. Con una lunghezza della faccia della forca compatta di soli 400 mm e un peso di servizio ridotto di 120 kg, l’F4 è altamente manovrabile in spazi ristretti e confinati.
        </span>
      ),
    },
    {
      question: "Quali caratteristiche di sicurezza offre l'F4?",
      answer: (
        <span>
          L’F4 può essere dotato di ruote stabilizzanti per ridurre il rischio di ribaltamento su superfici irregolari e carichi pesanti, migliorando la sicurezza dell’operatore e la stabilità del carico.
        </span>
      ),
    },
    {
      question: "In quali ambienti è più efficace l'F4?",
      answer: (
        <span>
          L’F4 è versatile e può essere utilizzato nel commercio al dettaglio, nei magazzini e nei centri logistici. È adatto per la movimentazione occasionale così come per applicazioni intensive a turno completo grazie al suo sistema di batterie modulare.
        </span>
      ),
    },
  ];

  const percheScegliereContent = [
    {
      title: 'Perché scegliere F4?',
      description: "L'F4 è ideale per una vasta gamma di ambienti, dall'uso nel commercio al dettaglio leggero alle operazioni logistiche intensive. La sua dimensione compatta (lunghezza della faccia della forca di 400 mm) e il peso di servizio ridotto lo rendono altamente manovrabile in spazi ristretti, mentre il design con slot per doppia batteria garantisce un funzionamento continuo per turni prolungati. Le ruote stabilizzanti opzionali migliorano la sicurezza durante la movimentazione di carichi grandi o pesanti, rendendo l'F4 una soluzione affidabile per magazzini, negozi al dettaglio e nodi di trasporto.",
      features: [
        {
          title: 'Sistema Batteria Flessibile',
          description: "L'F4 supporta fino a due batterie Li-ion rimovibili da 24V/20Ah, offrendo un'autonomia estesa per applicazioni intensive o flessibilità di ricarica opportunistica."
        },
        {
          title: 'Compatto e leggero',
          description: "Con una lunghezza della faccia delle forche di soli 400 mm e un peso di servizio ridotto di solo 120 kg, l'F4 è altamente manovrabile in corridoi stretti e spazi ristretti."
        },
        {
          title: 'Ruote stabilizzanti opzionali',
          description: "Per gestire in sicurezza carichi più pesanti o irregolari, l'F4 può essere dotato di ruote stabilizzanti, disponibili dalla fabbrica o come retrofit."
        },
        {
          title: 'Forche personalizzabili',
          description: "Disponibile in varie lunghezze e larghezze, l'F4 si adatta ai diversi standard di pallet e alle applicazioni specifiche dei clienti."
        }
      ],
      ctaTitle: 'Non aspettare troppo!',
      ctaButtonText: 'Contattaci ora!'
    }
  ];

  return (
    <div id="container" className="flex flex-col min-h-screen relative">
      <div className="fixed bottom-8 right-4 z-50 w-32 h-32 bg-black text-white font-sans rounded-full flex flex-col items-center justify-center text-center font-black shadow-xl border-4 border-white transform rotate-12">
        <span className="text-xs">BLACK FRIDAY<br/>2025</span>
        <span className="text-sm mt-1">SOLO<br/>25 PEZZI</span>
      </div>
      <main className="flex-grow font-sans">
        <section>
          <ImmTesto firstcontent={firstcontent} />
        </section>

        <section>
          <LightEffectSection />
        </section>

        <section>
          <PercheScegliere content={percheScegliereContent} />
        </section>

       
        <section>
          <AccordionMoretti faqs={faqs} />
        </section>

        <section>
          <CtaTesto ctatesti={ctatesti}/>
        </section>

        <Footer />
      </main>
    </div>
  );
}
